import React, { useCallback, useEffect, useState } from "react";
import SelectArchiveFilters, { ISelectArchiveCategory, ISelectArchiveYearMonth } from "../../common/SelectArchiveFilters";
import { ArchiveArticle } from "../../helpers/interfaces/news";
import Link from "../../common/Link";
import { Col, Row } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import Pagination from "../../common/Pagination";
import { apiGet } from "../../services/Api";
import CssLoader from '../../components/cssloader/CssLoader';
import { TypeCategory, useMenuSingleton } from "../../singleton/menuSingleton";
import { useLocation } from "react-router-dom";
import moment from "moment";
import 'moment/locale/it';
import './blog.css';
import Advertising from "../../common/Advertising";
import PageMeta from "../../components/PageMeta";

export default function ArchivioPage() {
    const location = useLocation();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const {getMenu, getTypeToCategoriaMap} = useMenuSingleton();
    const pageLimit = 30;
    const pageNeighbours = 5;

    const years: ISelectArchiveYearMonth[] = [];
    for (let i = moment().year(); i >= 2012 ; i--) {
        years.push({
            value: i,
            label: String(i)
        })
    }

    const months: ISelectArchiveYearMonth[] = [
        { value: 1, label: "Gennaio" },
        { value: 2, label: "Febbraio" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Aprile" },
        { value: 5, label: "Maggio" },
        { value: 6, label: "Giugno" },
        { value: 7, label: "Luglio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Settembre" },
        { value: 10, label: "Ottobre" },
        { value: 11, label: "Novembre" },
        { value: 12, label: "Dicembre" },
    ];

    const typeToCategoria: TypeCategory[] = getTypeToCategoriaMap(getMenu().data);
    const typeCategories: TypeCategory[] = [];
    
    Object.keys(typeToCategoria).forEach((key: any) => {
        if (typeToCategoria[key].categoria) {
            typeCategories.push(typeToCategoria[key])
        }
    })

    const categories: ISelectArchiveCategory[] = typeCategories ? typeCategories.map((
        item: any
    ) => {
        return {
            label: item.label,
            value: item.categoria
        }
    }) : [];

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [year, setYear] = useState<ISelectArchiveYearMonth>(years[0]);
    const [month, setMonth] = useState<ISelectArchiveYearMonth>(months[moment().month()]);
    const [category, setCategory] = useState<ISelectArchiveCategory>(location.state?.categoryId ?
        categories[categories.findIndex((
            categoryItem: ISelectArchiveCategory
        ) => {
            return location.state.categoryId === categoryItem.value
        })] : (categories[0] ? categories[0] : {label: "", value: ""}));
    const [archiveData, setArchiveData] = useState<ArchiveArticle[]>([]);

    const getArchiveData = useCallback(async () => {
        setIsLoading(true);

        await apiGet<ArchiveArticle[], any>(
            '?op=archivio&idCategoria=' + (category.value !== ""
                    ? category.value
                    : (categories[0] ? categories[0] : {label: "", value: ""})) +
                '&mese='+ month.value + '&anno=' + year.value
        ).then((
            response: ArchiveArticle[]
        ) => {
            setArchiveData(response);
        }).finally(() => {
            setIsLoading(false);
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category, month, year])

    useEffect(() => {
        (async() => {
            getArchiveData();
        })();
    }, [getArchiveData]);

    const selectMonth: ISelectArchiveYearMonth[] = year.value === moment().year()
        ? months.slice(0, moment().month() + 1)
        : months;
    
    let count: number = 0;

    const paginationResults = archiveData && archiveData.length
        ? [...archiveData].splice(
            ((currentPage - 1) * pageLimit),
            pageLimit
        ) : [];

    return <>
        <PageMeta
            title="Archivio News - Calcio a 5 Live"
            description=""
            image=""
            url={document.location.href}
            type=""
        />
        <h1>Archivio</h1>
        <SelectArchiveFilters
            yearsOptions={years}
            selectedYear={year}
            onYearChange={(e) => {
                if (
                    e.value === moment().year() &&
                    month.value > moment().month()
                ) {
                    setMonth(months[moment().month()]);
                }

                setYear(e);
            }}
            monthsOptions={selectMonth}
            selectedMonth={month}
            onMonthChange={(e) => { setMonth(e) }}
            categoriesOptions={categories}
            selectedCategory={category}
            onCategoryChange={(e) => { setCategory(e); }}
        />
        <hr />
        <Row>
            <Col id="content" xs={12} lg={9}>
                <div className="pb-4 mb-2">
                    {paginationResults.map((value: ArchiveArticle, index: number) => {
                        count++;
                        return <React.Fragment key={index}>
                            <div className="archive-link py-3 my-1">
                                <Link href={`/articolo/${value.id}`} title={value.titolo}>
                                    {value.strDataPubblicazione} - <span className="author-name">{value.nomeAutore}</span> - <span className="title">{value.titolo}</span>
                                </Link>
                            </div>
                            {count % 10 === 0 && count < paginationResults.length
                                ? <Advertising
                                    code={'banner-cat' + (3 + (count / 10))}
                                    as="div"
                                    className='text-center py-4'
                                />
                                : <></>
                            }
                        </React.Fragment>
                    })}
                </div>
                <Pagination
                    totalRecords={archiveData?.length ?? 0}
                    pageLimit={pageLimit}
                    pageNeighbours={pageNeighbours}
                    currentPage={currentPage}
                    onPageChanged={(value: any) => { setCurrentPage(value) }}
                />
            </Col>
            <Col id="sidebar" xs={12} lg={3} className="pt-3">
                <Sidebar />
            </Col>
        </Row>

        <CssLoader active={isLoading} text="Caricamento dell'archivio in corso..." />
    </>
}